export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 4.75a7.25 7.25 0 000 14.5.75.75 0 010 1.5A8.75 8.75 0 1120.75 12a.75.75 0 01-1.5 0A7.25 7.25 0 0012 4.75z\" fill=\"#6F7488\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 8.75a3.25 3.25 0 00-.813 6.398.75.75 0 11-.374 1.452A4.752 4.752 0 0112 7.25a4.752 4.752 0 014.6 3.563.75.75 0 11-1.452.374A3.252 3.252 0 0012 8.75z\" fill=\"#6F7488\"/><path d=\"M21.779 20.121l-2.525-2.526a.168.168 0 01.023-.258l1.586-1.098a.616.616 0 00-.173-1.096l-7.076-2.123a.476.476 0 00-.594.593l2.123 7.076a.616.616 0 001.095.174l1.1-1.586a.168.168 0 01.257-.024l2.526 2.527c.24.24.63.24.87 0l.788-.788a.614.614 0 000-.87z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};